/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppealBooking
 */
export interface AppealBooking {
    /**
     * 
     * @type {number}
     * @memberof AppealBooking
     */
    estate: number;
    /**
     * 
     * @type {number}
     * @memberof AppealBooking
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof AppealBooking
     */
    readonly status?: AppealBookingStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof AppealBooking
     */
    readonly expiredAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AppealBooking
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppealBooking
     */
    readonly updatedAt?: Date;
}

export function AppealBookingFromJSON(json: any): AppealBooking {
    return AppealBookingFromJSONTyped(json, false);
}

export function AppealBookingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppealBooking {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'estate': json['estate'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'expiredAt': !exists(json, 'expiredAt') ? undefined : (json['expiredAt'] === null ? null : new Date(json['expiredAt'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function AppealBookingToJSON(value?: AppealBooking | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estate': value.estate,
    };
}

/**
* @export
* @enum {string}
*/
export enum AppealBookingStatusEnum {
    New = 'new',
    Expect = 'expect',
    Booked = 'booked',
    Expired = 'expired',
    Done = 'done',
    Canceled = 'canceled'
}


